import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';

export default class ShowFilesModal extends Component {

  state = {deleteKeys:[]};

  selectFiles = (e) => {
    let deleteKeys = this.state.deleteKeys;
    if(e.target.value === "true" && deleteKeys.indexOf(e.target.name)>=0) {
      deleteKeys.splice(deleteKeys.indexOf(e.target.name),1);
    } else if(e.target.value === "false") {
      deleteKeys.push(e.target.name);
    }
    this.setState({deleteKeys:deleteKeys});
  }

  render() {
    const { files, closeModal, deleteFiles } = this.props;
    const {deleteKeys} = this.state;
    return (
      <Modal
          open={true}
          onClose={closeModal}
          aria-labelledby="ModalHeader"
          centered={false}
          style = {{ overflow: 'auto' }}
          closeIcon
          size="fullscreen"
      >
        <Modal.Header>
            Uploaded Files
        </Modal.Header>
      <Modal.Content scrolling>
          <div className="row">
            <div className="form-group">
              <button className='btn btn-primary' onClick={()=>deleteFiles(deleteKeys)}>
                Delete Selected
              </button>
            </div>
          </div>
          <div className="row">
            <div className="col-12 mt20">
              {
                files && files.map((file, key) => {
                  return (<div className="mt20" key={key}>
                    <input type="checkbox" name={key} value={deleteKeys.indexOf(key.toString()) >=0 ? true : false} checked={deleteKeys.indexOf(key.toString()) >=0 ? true : false } onChange={this.selectFiles} />
                    <a href={file} target="_blank" rel="noopener noreferrer" style={{ marginLeft: 10 }}>
                      Show in full size
                    </a>
                    <br />
                    {  (file.indexOf(".mp4") > 0) ?
                        <video alt="video" className="help-files-video" controls style={{ width: '100%', maxHeight: '80vh' }}>
                         <source src={file} type="video/mp4" />
                         Your browser does not support the video tag.
                        </video>
                      :
                        <a href={file} target="_blank" rel="noopener noreferrer">
                          <iframe title={`pdf-${key}`} className="help-files-pdf" src={file} type="application/pdf" style={{ width: '100%', height: '80vh', border: 0, pointerEvents: 'none' }} />
                        </a>
                    }
                    <hr />
                </div>)
                })
              }
            </div>
          </div>
        </Modal.Content>
        <Modal.Actions>
          <button className='btn btn-default' onClick={closeModal} >Close</button>
          <button className='btn btn-primary ml20' onClick={()=>deleteFiles(deleteKeys)}>
            Delete Selected
          </button>
        </Modal.Actions>
      </Modal>
    );
  }
}
